module.exports = __webpack_public_path__ + "static/media/2B.b4a8bf70.jpg";